import { RouteHelper } from '..';

export const useRoute = () => {
	let routeHelper = new RouteHelper();
	return { routeHelper };
};
